import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type IRouteKeys =
  '/auth/login' | 
  '/' |
  '/geo-veles' |
  '/geo-veles/extracoes' |
  '/geo-veles/extracoes/download' |
  'geo-veles/projetos/' |
  '/dashboard/clientes/create' |
  '/dashboard/cadastro/cliente' |  
  '/dashboard/cadastro/cliente/create' |
  '/dashboard/cadastro/cliente/edit' |
  '/dashboard/cadastro/perfil' |
  '/dashboard/cadastro/perfil/create' |
  '/dashboard/cadastro/perfil/edit' |
  '/dashboard/cadastro/usuario' 



interface INavigationState {
  activeRoute: IRouteKeys
}

const initialState: INavigationState = {
  activeRoute: '/',
};

const navigationSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setActiveRoute(state, action: PayloadAction<{
      route: IRouteKeys,
      params?: any
    }>) {
      state.activeRoute = action.payload.route
    }
  },
});

export const { setActiveRoute } = navigationSlice.actions;
export const navigationReducer = navigationSlice.reducer;